import * as React from "react";
import type { SVGProps } from "react";
const SvgWallet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.62 15.92c.12.06.25.08.38.08.26 0 .52-.11.71-.29.09-.1.16-.2.21-.33.06-.12.08-.25.08-.38 0-.26-.11-.52-.29-.71a1 1 0 0 0-1.09-.21q-.18.075-.33.21c-.18.19-.29.45-.29.71 0 .13.03.26.08.38.05.13.12.23.21.33q.15.135.33.21"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.818 8.176c.335-.51.473-1.124.392-1.746-.09-.69-.44-1.3-.99-1.72l-4.14-3.18a2.594 2.594 0 0 0-3.63.48L5.85 8H3.94C2.87 8 2 8.87 2 9.94v10.1C2 21.12 2.88 22 3.96 22H18c1.1 0 2-.9 2-2v-1c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2v-1c0-.81-.487-1.51-1.182-1.824M8.378 8h1.74l3.379-4.398-.627-.482a.59.59 0 0 0-.83.11zm4.257 0h3.812l.673-.87c.1-.12.14-.28.12-.44a.57.57 0 0 0-.23-.39l-1.93-1.482zM17 19h1v1l-14 .04L3.94 10H18v1h-1c-1.65 0-3 1.35-3 3v2c0 1.65 1.35 3 3 3m0-6h3v4h-3c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgWallet;
